export function cookieExists(cookieName: string): boolean {
    const cookiePieces = decodeURIComponent(document.cookie)?.split(';') || [];
    const cookie = cookiePieces
        .find((piece) => piece.trim().startsWith(cookieName + '='))
        ?.trim();
    return cookie !== undefined;
}
